import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";
import {ActionsSubject} from "@ngrx/store";
import {ofType} from "@ngrx/effects";
import {BlockBaseComponent} from "../scene-blocks/block-base/block-base.component";
import {IBlockLabelsRecords} from "../scene-blocks/block-constants";
import {IAppSettingsWrap, ICRUDCommand, ICRUDRecord, IGlobalSettings, ISocialToken, IUser} from "../../../interfaces";
import {AppService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {DEFAULT_PORT, isNullOrUndefOrEmpty, isStringBasedJson, popupWindow, WEB_SERVER} from "../../../common";
import {timeout} from "../../../decorators/timeout";
import {actionCRUDRecord, actionSocialAddProfileKey, actionSocialCreateKey, actionSocialCreateSuccess, actionSocialCreateURL, actionSocialCreateURLSuccess, actionSocialRemoveKey, actionSocialRemoveKeySuccess} from "../../../store/actions/user.actions";
import {DialogPopComponent} from "../../../components/dialog-pop/dialog-pop.component";
import {DialogCorsComponent} from "../../../components/dialog-cors/dialog-cors.component";
import {Lib} from "../../../../libs/Lib";


@Component({
    selector: 'app-scene-social-token',
    templateUrl: './scene-social-token.component.html',
    styleUrls: ['./scene-social-token.component.scss']
})
export class SceneSocialTokenComponent extends BlockBaseComponent {

    totalStockSymbols = 0;
    transitionsEnabled = '0';
    enterprise: boolean;
    globalSettings: IGlobalSettings;
    isCreatedDisabled = false;
    isLoadingSocialKey = false;
    isLoadingSocialURL = false;
    isSocialInit = true;
    coreAppData: IAppSettingsWrap;
    m_user: IUser;

    public socialKey: ISocialToken;

    @Input() miniMode = false;

    @Output() changed: EventEmitter<any> = new EventEmitter();

    constructor(
        private cd: ChangeDetectorRef,
        private translocoService: TranslocoService,
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        private actionsSubj: ActionsSubject,
        private appService: AppService,
        private toastr: ToastrService,
        protected override localStoreService: LocalStoreService
    ) {
        super(storeSelector, dialog);

        /** fix bug if user moves from one social component  tp another while he just created a token **/
        setTimeout(() => {
            this.isSocialInit = false;
            this.cd.detectChanges();
        }, 2000);
    }

    override onInit() {
        this.cod(
            this.storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.m_user = user;
                })
        );
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => {
                    this.enterprise = i_coreData[0].enterprise;
                    this.coreAppData = i_coreData;
                })
        );
        this.cod(
            this.storeSelector.getGlobalSettings('ayreshare_token')
                .subscribe((globalSettings) => {
                    this.globalSettings = globalSettings[0];
                    const a: ISocialToken | any = globalSettings[0].param_value;
                    if (isStringBasedJson(a)) {
                        this.socialKey = JSON.parse(a) as ISocialToken;
                    } else {
                        this.socialKey = a as ISocialToken;
                    }
                    this.updateFormSocialKey();
                    this.changed.emit({socialKey: this.socialKey});
                    // if (isHostDevOrLocal()) {
                    //     const refId = this.socialKey.refId;
                    //     console.log(`https://secure.digitalsignage.com/socialFeed/${refId}/twitter`);
                    // }
                })
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionSocialRemoveKeySuccess))
                .subscribe((reply) => {
                    if (reply.socialReply.status === 'success') {
                        // disabled as we do all cleanup in server side now
                        // this.crudGlobalSettings('delete', reply.socialReply.paramId, null);
                        this.toastr.success('deleted social key');
                    } else {
                        this.toastr.error('problem deleting social key');
                    }
                })
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionSocialCreateURLSuccess))
                .subscribe((reply) => {
                    if (reply.socialReply.status === 'success') {
                        popupWindow({url: reply.socialReply.url, title: 'social connections', w: '600px', h: '400px'});
                        return;
                    }
                    this.toastr.error('key expired due to lack of use, delete it and create a fresh one...');
                })
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionSocialCreateSuccess))
                .subscribe((reply) => {
                    if (reply.socialReply.status === 'error') {
                        this.isLoadingSocialURL = false;
                        this.isLoadingSocialKey = false;
                        this.toastr.error(reply.socialReply.message);
                        this.cd.detectChanges();
                        return;
                    }
                    if (reply.socialReply.exists) {
                        // this.storeSelector.dispatch(actionSocialRemoveKeyWithBusinessId({}));
                        this.cd.detectChanges();
                        return this.toastr.warning('Oops... a social key already exists, refresh to update...');
                    }
                    this.crudGlobalSettingsAdd({profileKey: reply.socialReply.profileKey, refId: reply.socialReply.refId});
                    // this.toastr.success('Success, social access key created');
                    this.socialKey = {
                        profileKey: reply.socialReply.profileKey,
                        refId: reply.socialReply.refId
                    };
                    this.isLoadingSocialURL = false;
                    this.isLoadingSocialKey = false;

                    this.cd.detectChanges();
                })
        );
    }

    @timeout(333)
    updateFormSocialKey() {
        if (isNullOrUndefOrEmpty(this.socialKey)) return;
        this.setFormValue('token', this.socialKey.profileKey);
        this.cd.markForCheck();
    }

    private crudGlobalSettingsAdd(i_socialKey: ISocialToken) {
        const saveRecord: ICRUDRecord = {
            studioId: this.localStoreService.getStorageConfig().studioId,
            command: 'add',
            primary: 'param_id',
            table: 'global_settings',
            body: {param_key: 'ayreshare_token', param_value: i_socialKey},
            id: null
        };
        this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
            /** important dont update store since server command failed **/
            if (!i_crudReply.serverReply.status) return;
            const id = String(i_crudReply.serverReply.id);
            const globalSettings: IGlobalSettings = {
                param_id: id,
                param_value: {profileKey: i_socialKey.profileKey, refId: i_socialKey.refId},
                param_key: 'ayreshare_token'
            };
            this.storeSelector.dispatch(actionSocialAddProfileKey({
                data: globalSettings
            }));
        });
    }

    private crudGlobalSettings(command: ICRUDCommand, id, body) {
        this.storeSelector.dispatch(actionCRUDRecord({
            saveRecord: {
                studioId: this.localStoreService.getStorageConfig().studioId,
                command,
                primary: 'param_id',
                table: 'global_settings',
                body,
                id
            }
        }));
    }

    onCreateNewSocialKey() {
        if (!this.enterprise) {
            this.appService.openWizardUpgradeDialog();
            return;
        }
        if (Lib.IsAccessBlocked(this.m_user)) {
            return this.toastr.error(this.translocoService.translate('account.screenDisruption', {}, this.translocoService.getActiveLang()), '[ Contact live chat ]');
        }
        this.isLoadingSocialKey = true;
        this.storeSelector.dispatch(actionSocialCreateKey({}));
    }

    openCors() {
        this.dialog.open(DialogCorsComponent, {
            width: '400px'
        });
    }


    onCreateSocialURL() {
        this.isLoadingSocialURL = true;
        this.cd.markForCheck();
        this.storeSelector.dispatch(actionSocialCreateURL({socialKey: this.socialKey}));
        setTimeout(() => {
            this.isLoadingSocialURL = false;
            this.cd.markForCheck();
        }, 5000);
    }

    onCreateSocialTest() {
        let name: string;
        switch (this.sceneItem.$.player) {
            case this.blockLabelRecords.GOOGLE_BUSINESS_AYRSHARE.id: {
                name = 'gmb';
                break;
            }
            case this.blockLabelRecords.FACEBOOK_GROUPS_AYRSHARE.id: {
                name = 'fbg';
                break;
            }
            case this.blockLabelRecords.INSTAGRAM_AYRSHARE.id: {
                name = 'instagram';
                break;
            }
            default: {
                name = this.storeSelector.getBlockLabelById(this.sceneItem.$.player).name;
            }
        }
        name = name.toLowerCase();
        const url = `${WEB_SERVER}:${DEFAULT_PORT}/socialFeed/${this.socialKey.refId}/${name}`;
        popupWindow({url, title: 'Test social connection', h: 200, w: 300});
    }

    onRemoveSocialKey() {
        const localRemText1 = this.translocoService.translate('general.areYouSure', {}, this.translocoService.getActiveLang());
        const localRemText2 = this.translocoService.translate('general.removeSocial', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '265px',
            width: '400px',
            data: {name: `${localRemText1} ${localRemText2}?`, showCancel: true}
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                this.storeSelector.dispatch(actionSocialRemoveKey({
                        paramId: this.globalSettings.param_id,
                        socialKey: this.socialKey.profileKey
                    })
                );
                this.socialKey = null;
                this.changed.emit({socialKey: null});
                this.setFormValue('token', '');
                this.isCreatedDisabled = true;
                this.cd.markForCheck();
                setTimeout(() => {
                    this.isCreatedDisabled = false;
                    this.cd.markForCheck();
                }, 5000);
            }
        });
    }
}



